import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ControllersInvoker, IAppWillLoadPageHandler, SdkHandlersProvider } from '@wix/thunderbolt-symbols'

export type ControllersSdkHandlers = {
	controllers: {
		registerToConfigUpdate: (controllerId: string, onConfigUpdateFunc: Function) => void
		registerExportsSetter: (controllerId: string, setExportsFunc: Function) => void
		registerToAppSettingsUpdate: (controllerId: string, onConfigUpdateFunc: Function) => void
		registerToWidgetViewStateUpdate: (controllerId: string, onWidgetViewStateUpdateFunc: Function) => void
		registerPageReady: (controllerId: string, onControllerPageReady: Function) => void
	}
}

export const platformControllersHandler = withDependencies([], (): ControllersInvoker & SdkHandlersProvider<ControllersSdkHandlers> & IAppWillLoadPageHandler => {
	let controllerOnConfigUpdateMapper: { [controllerId: string]: Function } = {}
	let controllerExportSettersMapper: { [controllerId: string]: Function } = {}
	let controllerOnAppSettingsUpdateMapper: { [controllerId: string]: Function } = {}
	let controllerOnWidgetViewStateUpdateMapper: { [controllerId: string]: Function } = {}
	let controllerPageReadyMapper: { [controllerId: string]: Function } = {}

	return {
		name: 'platformControllersHandler',
		getSdkHandlers: () => ({
			controllers: {
				registerToConfigUpdate: (controllerId, onConfigUpdateFunc) => {
					controllerOnConfigUpdateMapper[controllerId] = onConfigUpdateFunc
				},
				registerExportsSetter: (controllerId, setExportsFunc) => {
					controllerExportSettersMapper[controllerId] = setExportsFunc
				},
				registerToAppSettingsUpdate: (controllerId, onAppSettingsUpdateFunc) => {
					controllerOnAppSettingsUpdateMapper[controllerId] = onAppSettingsUpdateFunc
				},
				registerToWidgetViewStateUpdate: (controllerId, onWidgetViewStateUpdateFunc) => {
					controllerOnWidgetViewStateUpdateMapper[controllerId] = onWidgetViewStateUpdateFunc
				},
				registerPageReady: (controllerId, onControllerPageReady) => {
					controllerPageReadyMapper[controllerId] = onControllerPageReady
				},
			},
		}),
		invokeConfigUpdate(controllerId, updatedConfig) {
			const onConfigUpdateFunc = controllerOnConfigUpdateMapper[controllerId]
			if (onConfigUpdateFunc) {
				onConfigUpdateFunc(updatedConfig)
			}
		},
		isRegisteredToConfigUpdate(controllerId) {
			return !!controllerOnConfigUpdateMapper[controllerId]
		},
		invokePropsSetters(controllerId, props) {
			const setExportsFunc = controllerExportSettersMapper[controllerId]
			if (setExportsFunc) {
				setExportsFunc(props)
			}
		},
		revokeUpdates(controllerId) {
			delete controllerOnConfigUpdateMapper[controllerId]
			delete controllerOnAppSettingsUpdateMapper[controllerId]
		},
		invokeAppSettingsUpdate(controllerId, updatedConfig) {
			const onAppSettingsUpdateFunc = controllerOnAppSettingsUpdateMapper[controllerId]
			if (onAppSettingsUpdateFunc) {
				onAppSettingsUpdateFunc(updatedConfig)
			}
		},
		invokeWidgetViewStateUpdate(controllerId, widgetViewState) {
			const onWidgetViewStateUpdateFunc = controllerOnWidgetViewStateUpdateMapper[controllerId]
			if (onWidgetViewStateUpdateFunc) {
				onWidgetViewStateUpdateFunc(widgetViewState)
			}
		},
		async invokePageReady(controllerId) {
			const pageReady = controllerPageReadyMapper[controllerId]
			if (pageReady) {
				await pageReady()
			}
		},
		appWillLoadPage() {
			controllerOnConfigUpdateMapper = {}
			controllerExportSettersMapper = {}
			controllerOnAppSettingsUpdateMapper = {}
			controllerPageReadyMapper = {}
			controllerOnWidgetViewStateUpdateMapper = {}
		},
	}
})
